import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded"
import { Stack, Typography } from "@mui/material"
import { ReactElement } from "react"

import DashboardPanelFrame from "../../components/dashboard/dashboardPanelFrame"
import SingleKpiCard from "../../components/dashboard/singleKpiCard"
import DashboardHomepageSkeleton from "../../components/loading/skeletons/dashboardHomepageSkeleton"
import { DB_ASSESSOR_V2G, DISPLAY_ROLES } from "../../constants/roles"
import { useGetUserData } from "../../hooks/useGetUserData"
import { V2G_AWAITING_ASSESSMENT_DEVICES } from "../../router/routes"
import useSearchV2gDevices from "../../services/middleware/hooks/useSearchV2gDevices"
import { GRID_SPACING } from "../../themes/defaultThemeParams"

/**
 * Renders the dashboard for V2G Assessor users which is displayed as their homepage
 */
const V2gAssessorHomepage = (): ReactElement => {
    const { firstName } = useGetUserData()
    const { data, isError, isLoading } = useSearchV2gDevices()

    if (isLoading) {
        return <DashboardHomepageSkeleton />
    }
    if (isError) {
        return <Typography>Error loading V2G data</Typography>
    }
    if (!data) {
        return <Typography>V2G Data Currently Unavailable</Typography>
    }

    return (
        <Stack
            direction={{ xs: "column", md: "column" }}
            spacing={GRID_SPACING}
            alignItems="stretch"
        >
            <Stack>
                <DashboardPanelFrame
                    userName={firstName}
                    permission={DISPLAY_ROLES[DB_ASSESSOR_V2G]}
                />
            </Stack>

            <Stack
                direction={{ xs: "column", md: "row" }}
                gap={GRID_SPACING}
                justifyContent="center"
                marginBottom={GRID_SPACING}
            >
                <SingleKpiCard
                    Icon={HourglassTopRoundedIcon}
                    value={data.totalResults}
                    title="V2G Bundles to Assess"
                    link={V2G_AWAITING_ASSESSMENT_DEVICES}
                />
            </Stack>
        </Stack>
    )
}

export default V2gAssessorHomepage
